import { jsx } from "react/jsx-runtime";
import { Radio } from "@base-ui-components/react/radio";
import { cn } from "../../../utils/index.js";
import { radioButtonVariants } from "./Radio.variants.js";
function RadioButton(props) {
    const { value, disabled, emphasis, radioButtonClassName, name, size = '20' } = props;
    const { radioRoot, radioIndicator } = radioButtonVariants({
        emphasis,
        size,
        disabled
    });
    const classes = cn(radioRoot(), radioButtonClassName);
    return /*#__PURE__*/ jsx(Radio.Root, {
        value: value,
        className: classes,
        disabled: disabled,
        name: name,
        children: /*#__PURE__*/ jsx(Radio.Indicator, {
            className: radioIndicator()
        })
    });
}
export { RadioButton };
